export default function scheduleMicrotask(callback: () => any) {
  Promise.resolve().then(callback);
}
